import router from './router'
import store from './store/index'

router.beforeEach(async (to, from, next) => {
  // 如果已经登录则不做拦截
  if (store.state.passport) {
    next()
    return
  }
  // 白名单不校验是否登录
  const whiteList = ['/', '/login', '/sign', '/pricie', '/locations', '/userinfo/requestcomplete']
  const isWhiteListPage = whiteList.some((item) => item === to.path)
  console.log('🚀 ~ permission.js:13 ~ isWhiteListPage:', isWhiteListPage)
  // 如果未登录 且在白名单页面直接进入
  if (isWhiteListPage) {
    next()
    return
  }
  // 以上条件都为满足(已登录、白名单)  则跳转登录页面

  store.commit('SET_AFTER_LOGIN_PATH', to.path) // 设置登录后的重定向路径
  next('/login', () => {
    console.log('重定向到login页面')
  })
})
